$(document).ready(function () {
  if ($(".DocumentLibrary").length > 0) {

    var form = $(".document-library-controls");
    var url = form.data("url");

    // set to default latest quarter on load
    retrieveDocuments();

    // checkPeriodDropdownVisibility(form.find('[name="Fund"]').val());

    form.find("input, select").change(function (e) {
      e.preventDefault();

      // show loader and hide table
      $(".document-library-loader").show();
      $(".document-library-content").hide();

      // checkPeriodDropdownVisibility(form.find('[name="Fund"]').val());

      retrieveDocuments();      
    });

    function retrieveDocuments() {
      $.ajax({
        type: "GET",
        url: url,
        data: form.serialize(),
        success: function (response) {

          // hide loader, put new content into table and show
          $(".document-library-loader").hide();
          $(".document-library-content").html(response).show();

          var newUrl = $(".docs__all").data("url");
          history.pushState(null, null, newUrl);
        },
      });
    }


    function checkPeriodDropdownVisibility(selectedType) {
      var typesWithPeriod = $('.document-library.filter-form').data('funds');
      var periodHolder = form.find('.document-filter-period-holder');     

      if (typesWithPeriod.includes(parseInt(selectedType))) {
        periodHolder.removeClass('document-filter-hidden');
      } else {
        periodHolder.addClass('document-filter-hidden');
      }
    }
  }
});



// $(document).ready(function (e) {
//   if ($(".DocumentLibrary, .related-documents").length > 0) {
//     var dom = $(".DocumentLibrary, .related-documents");

//     var document_filter_form_wrapper = $(".document-library.filter-form");
//     var document_filter_form = document_filter_form_wrapper.find("form");
    
//     if (document_filter_form.length > 0) {
//       var document_filter_form_period = document_filter_form.find('[name="Period"]');
//       var document_filter_form_fund = document_filter_form.find('[name="Fund"]');
//       // var document_filter_form_datesort = document_filter_form.find('[name="SortDate"]:checked');
//       // var document_filter_form_titlesort = document_filter_form.find('[name="SortTitle"]:checked');
//       var document_table = $(".document-library-content");

//       filter_library_documents();

//       // Fetch on form field change
//       document_filter_form.on("change", "select, input", function (e) {
//         filter_library_documents();
//       });

      
//       // if Type is changed, show the Period dropdown if Type is in array
//       var typesWithPeriod = ['1','2'];

//       document_filter_form_fund.on("change", function (e) {
//         var selectedType = document_filter_form_fund.val();
//         var periodHolder = document_filter_form.find('.document-filter-period-holder');
       
//         if (typesWithPeriod.includes(selectedType)) {
//           periodHolder.removeClass('document-filter-hidden');
//         } else {
//           periodHolder.addClass('document-filter-hidden');
//         }
//       });

//     }

//     /**
//      * Call our endpoint for more pricing data
//      * Simple fetch via Ajax with chained rendering
//      **/
//     function filter_library_documents() {
//       var url = document_filter_form_wrapper.attr("data-endpoint");

//       // Remove stage parameters from filtering
//       if (url.indexOf("?stage=Stage") >= 0) {
//         url = url.replace("?stage=Stage", "");
//       } else if (url.indexOf("?stage=Live") >= 0) {
//         url = url.replace("?stage=Live", "");
//       }

//       // Set object to hold params, so can output with ? & as required
//       var urlSegments = new URLSearchParams();

//       if (
//         document_filter_form_period.length > 0 &&
//         document_filter_form_period.val()
//       ) {
//         urlSegments.append("Period", document_filter_form_period.val());
//       }

//       if (
//         document_filter_form_fund.length > 0 &&
//         document_filter_form_fund.val()
//       ) {
//         urlSegments.append("Fund", document_filter_form_fund.val());
//       }

//       urlSegments.append("SortDate", document_filter_form.find('[name="SortDate"]:checked').val());
//       urlSegments.append("SortTitle", document_filter_form.find('[name="SortTitle"]:checked').val());

//       url = url + "?" + urlSegments.toString();

//       document_loader = dom.find(".loader");
//       document_loader.show();
//       document_table.hide();

//       $.ajax({
//         type: "GET",
//         url: url,
//         success: function (response) {

//           document_loader.hide();
//           document_table.html(response).show();

//           // update browser history url
//           var newUrl = window.location.pathname + "?" + urlSegments.toString();
//           window.history.pushState({}, "", newUrl);
//         },
//       });
//     }
//   }
// });
